<template>
      <div class="modal" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <iframe 
          v-if="selectPlugin != null" 
          id="show-plugin"
          @hook:mounted="damNotificationCallback()"
          style="width:100%;height:100%;" 
          ref="iframeExternalPluginDialog" 
          frameBorder="0"></iframe>
      </div>
      </div>
</template>


<script>
import {mapMutations} from "vuex"
export default {
    data(){
      return{
        seletedPlugin:null,
        iframeController:null,
        selectedFilesFromParent:{}
      }
    },
    watch: {
      pluginInfo(ol, nl) {
        if (ol != nl) {
          setTimeout(() => this.selectPlugin(this.pluginInfo.plugin_name), 100);
        }
      },
       immediate:true,
      "selectedFilesFromParent.singlefile":function () {
        this.damNotificationCallback();
      }
    },
    methods:{
        selectPlugin(plugin){
          this.seletedPlugin = plugin;
          this.loadExternalPluginContextMenuDialogUI({id:this.pluginInfo.id, pluginName: this.seletedPlugin,tagId: "show-plugin"})// eslint-disable-line no-undef
          this.iframeController = this.$refs.iframeExternalPluginDialog.contentWindow;
        },
        damNotificationCallback() {
            window.addEventListener('message', (event)=>{
                  let cmd = event.data.cmd
                  switch (cmd) {
                    case 'readyToListenMessage':{
                        this.iframeController.postMessage({
                          cmd: 'fileinfo',
                          params: {
                            selected_file_info:this.selectedFilesFromParent
                          }
                          }, '*')
                        break;
                      }
                    default:
                      break;
                  }
                }
                )
          },
        listenMessagesFromChild(){
                window.addEventListener('message', (event)=>{
                  let cmd = event.data.cmd;
                  switch (cmd) {
                    case 'closeWindow':{
                      this.$emit("close")
                      break;
                    }
                    default:
                      break;
                  }
                }
                )
              },
        ...mapMutations("registry",["loadExternalPluginContextMenuDialogUI"]),
    },
    props:["pluginInfo","fileInfo"],
    created(){
      this.selectedFilesFromParent = this.fileInfo;
      this.listenMessagesFromChild();
      this.damNotificationCallback();
    },
    mounted() {
      setTimeout(() => {this.selectPlugin(this.pluginInfo.plugin_name)
      }, 100);
    },

}
</script>


<style lang="scss" scoped>
$header-background: #1a1a1a;
$border-color: 1px solid #1a1a1a;
$background: #121212;
$bg-color-on-hover: #141414;
$body-bg-color: #141414;
$dull-text-color: #757575;
$options-text-color: #9c9c9c;
$text-color: #eee;
$table-row-border: none;
$active-blue : #007bff;
$modal-border:1px solid #202020;
$modal-background: #121212;
$header-color:#9e9e9e;

.modal-dialog {
    width: 100vw;
    height: 100vh;
    max-width:100%;
    margin: 0;
    padding: 0;
    pointer-events: all;
  }

.modal-content {
  height: auto;
  min-height: 100%;
  border: 0 none;
  border-radius: 0;
  box-shadow: none;
  background: $body-bg-color !important;
  border: $modal-border;
  .modal-body{
    background: $modal-background;
    overflow:auto;
    height:300px;
    padding: 0px 0px 0px 0px;
    display:inline-flex;
    width:100%;
  }
}

.modal {
  text-align: center;
  padding: 0!important;
  display:block;
}
.modal:before {
  content: '';
  display: inline-block;
  height: 100%;
  vertical-align: middle;
  margin-inline-end: -4px;
}
.modal-dialog {
  display: inline-block;
  text-align: start;
  vertical-align: middle;
}
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: $text-color;
  letter-spacing: normal;
  margin-top: 60px;
  background: $body-bg-color !important;
  font-size: 14px !important;
  margin-block-start: 0em !important;
  margin-block-end: 0em !important;
  cursor: pointer;
  overflow: hidden;
}


body {
  background: $body-bg-color !important;
  color: $text-color;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: $text-color;
  letter-spacing: normal;
  margin-top: 60px;
  background: $body-bg-color !important;
  height: 100%;
  font-size:14px !important;
  margin-block-start: 0em !important;
  margin-block-end: 0em !important;
  cursor: pointer;
  overflow:hidden;
}

html{
  overflow: auto;
}

select option {
    margin: 40px;
    background: #000;
    color: #fff;
    text-shadow: 0 1px 0 rgba(0, 0, 0, 0.4);
}
</style>


